import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import AuthLayout from "../../components/layout/auth-layout.component";
import { Button, Field, TextInput } from "../../components/ui";

const SignUp = () => {
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [nameError, setNameError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    // The payments provider requires a name of at least three characters.
    if (displayName.trim().length < 3) {
      setNameError("Name should have at least 3 characters.");
      return;
    }
    setNameError("");

    const toastId = toast.loading("Creating your account...");
    setIsLoading(true);
    try {
      await axios.post("/app-api/user/register", { displayName, email, password });
      toast.update(toastId, {
        render: "Account created. Please sign in.",
        type: "success",
        isLoading: false,
        autoClose: 2000,
        delay: 100,
      });
      navigate("/signin");
    } catch (err) {
      console.error(err);
      toast.update(toastId, {
        render: err.response?.data?.errorMessage || "Something went wrong.",
        type: "error",
        isLoading: false,
        autoClose: 2000,
        delay: 100,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Set up MedpeR for yourself or someone you care for."
      footer={
        <p className="text-sm text-gray-500">
          Already have an account?{" "}
          <button onClick={() => navigate("/signin")} className="font-semibold text-primary-600 hover:underline">
            Sign in
          </button>
        </p>
      }
    >
      <form onSubmit={handleSubmit}>
        <Field label="Name" error={nameError} htmlFor="signup-name">
          <TextInput
            id="signup-name"
            type="text"
            required
            autoComplete="name"
            value={displayName}
            invalid={Boolean(nameError)}
            placeholder="Your full name"
            onChange={(e) => setDisplayName(e.target.value.trim())}
          />
        </Field>

        <Field label="Email" htmlFor="signup-email">
          <TextInput
            id="signup-email"
            type="email"
            required
            autoComplete="email"
            value={email}
            placeholder="name@example.com"
            onChange={(e) => setEmail(e.target.value.trim())}
          />
        </Field>

        <Field label="Password" htmlFor="signup-password">
          <TextInput
            id="signup-password"
            type="password"
            required
            autoComplete="new-password"
            value={password}
            placeholder="At least 6 characters"
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>

        <Button type="submit" size="lg" loading={isLoading} className="w-full">
          Create account
        </Button>

        <p className="mt-4 text-center text-[11px] leading-relaxed text-gray-500">
          By signing up you agree to our{" "}
          <a
            href="https://www.medper.in/terms-and-conditions"
            target="_blank"
            rel="noreferrer"
            className="font-medium text-primary-600 hover:underline"
          >
            Terms &amp; Conditions
          </a>{" "}
          and{" "}
          <a href="https://www.medper.in/privacy-policy" target="_blank" rel="noreferrer" className="font-medium text-primary-600 hover:underline">
            Privacy Policy
          </a>
          .
        </p>
      </form>
    </AuthLayout>
  );
};

export default SignUp;
